export const trLocale = {
	months: [
		"Ocak",
		"Şubat",
		"Mart",
		"Nisan",
		"Mayıs",
		"Haziran",
		"Temmuz",
		"Ağustos",
		"Eylül",
		"Ekim",
		"Kasım",
		"Aralık",
	],
	monthsShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
	weekdays: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
	weekdaysShort: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
	weekdaysMin: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
	longDateFormat: {
		LT: "HH:mm",
		LTS: "HH:mm:ss",
		L: "DD.MM.YYYY",
		LL: "D MMMM YYYY",
		LLL: "D MMMM YYYY HH:mm",
		LLLL: "dddd, D MMMM YYYY HH:mm",
	},
	calendar: {
		sameDay: "[Bugün saat] LT",
		nextDay: "[Yarın saat] LT",
		nextWeek: "dddd [saat] LT",
		lastDay: "[Dün saat] LT",
		lastWeek: "[Geçen] dddd [saat] LT",
		sameElse: "L",
	},
	relativeTime: {
		future: "%s içinde",
		past: "%s önce",
		s: "birkaç saniye",
		ss: "%d saniye",
		m: "bir dakika",
		mm: "%d dakika",
		h: "bir saat",
		hh: "%d saat",
		d: "bir gün",
		dd: "%d gün",
		M: "bir ay",
		MM: "%d ay",
		y: "bir yıl",
		yy: "%d yıl",
	},
	dayOfMonthOrdinalParse: /\d{1,2}\./,
	ordinal: (n: number) => `${n}.`,
	week: {
		dow: 1, // Monday is the first day of the week.
		doy: 4, // The week that contains Jan 4th is the first week of the year.
	},
};
